import { memo, useCallback, useMemo } from "react";
import { useTranslate } from "helpers";
import { NotificationScope } from "services/api/notifications/types";
import { getScopeCardOptions, ENTITY_TYPE_LABELS } from "services/api/notifications/consts";
import { CardSelect } from "ui/components/CardSelect";

interface Props {
  scope: NotificationScope;
  entityType: number | null;
  error?: string;
  onChange: (scope: NotificationScope) => void;
}

const ScopeSelector: React.FC<Props> = ({ scope, entityType, error, onChange }) => {
  const { t } = useTranslate();

  const options = useMemo(() => {
    const entityLabel = entityType != null ? ENTITY_TYPE_LABELS[entityType] ?? "" : "";

    return getScopeCardOptions(entityLabel);
  }, [entityType]);

  // CardSelect barata string id-jevima; opseg je enum broj, pa se vraća natrag.
  const handleChange = useCallback(
    (id: string) => onChange(Number(id) as NotificationScope),
    [onChange]
  );

  return (
    <div className="mb-3">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {t("admin.notification.field.scope")} <span className="text-red-500">*</span>
      </label>

      <CardSelect
        options={options}
        value={String(scope)}
        onChange={handleChange}
        columns={2}
        error={error}
      />
    </div>
  );
};

export default memo(ScopeSelector);
